import { render, staticRenderFns } from "./simple-snackbar.vue?vue&type=template&id=68d2197c&scoped=true"
import script from "./simple-snackbar.vue?vue&type=script&lang=js"
export * from "./simple-snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2197c",
  null
  
)

export default component.exports